import { FONT_FAMILY } from 'styles/typography'

const themeStyles = colors => {
  const styles = {
    segment: {
      backgroundColor: colors.textWhite,
      color: colors.placeHolderText,
      fontFamily: FONT_FAMILY,
      position: 'relative',
      bottom: 0
    },
    container: {
      height: 'auto',
      fontSize: '12px !important'
    },
    text: {
      color: colors.lightGray,
      fontFamily: FONT_FAMILY,
      fontSize: 11,
      fontWeight: 500,
      lineHeight: '16px',
      textAlign: 'center'
    },
    link: { color: colors.lightBlack },
    footerLineText: {
      overflowWrap: 'break-word'
    }
  }

  return styles
}

export default themeStyles
